import { ActionBase } from '@/models/action_base';
import { KbnConst } from '@/utils/kbn';

import { useActionDataClear } from './use_action_data_clear';
import { useActionPurchaseItemsCheck } from './use_action_purchase_items_check';
import { useActionRedirectIfNotEntried } from './use_action_redirect_if_entried';
import { useRouting } from './use_routing';

/**
 * カスタマイズアクション
 */
export class ActionCustomizing extends ActionBase {
  typeKbn = KbnConst.ACTION_TYPE_KBN_CUSTOMIZING;

  keyName?: string;

  use() {
    const router = useRouting();
    return async () => await execute(this.keyName, router);
  }

  constructor(init: Partial<ActionCustomizing> = {}) {
    super();
    Object.assign(this, init);
  }
}

async function execute(
  keyName: string | undefined,
  router:  ReturnType<typeof useRouting>,
) {
  const purchaseItemsCheck = useActionPurchaseItemsCheck();

  const redirectIfNotEntried = useActionRedirectIfNotEntried(router, 'survey');

  const dataClear = useActionDataClear();

  if (keyName === 'purchase_items_check') {
    return await purchaseItemsCheck();
  } else if (keyName === 'is_input_completed') {
    return false; //設定したアクションは他で確認するため、特に何もしない
  } else if (keyName === 'redirect_survey_if_not_entried') {
    return redirectIfNotEntried();
  } else if (keyName === 'data_clear') {
    return dataClear();
  }

  // キー名を使って好きな処理を実行できる
  alert(`このアクションは未実装（キー名: ${ keyName }）`);
  return false;
}

export function generateActionCustomizing(keyName?: string): ActionCustomizing {
  return new ActionCustomizing({
    keyName,
  });
}
